var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "viewer-dialog-box" }, [
    _c("div", { staticClass: "img-box" }, [
      _c(
        "div",
        {
          directives: [{ name: "viewer", rawName: "v-viewer" }],
          ref: "viewer",
          staticClass: "img-wrap"
        },
        _vm._l(_vm.srcList, function(src, index) {
          return _c("img", {
            key: index,
            staticStyle: { width: "100%" },
            attrs: { src: src }
          })
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6a08fc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6a08fc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Public/ImgViewer.vue
// module id = null
// module chunks = 